const fillWithZeros = value => (value < 10 ? '0' : '') + value;

const hours24Options = new Array(24).fill(0).map((item, index) => ({
  id: index.toString(),
  value: index,
  name: fillWithZeros(index),
}));

const hours12Options = [
  ...hours24Options.slice(1, 12),
  {
    ...hours24Options[0],
    name: '12',
  },
];

const minutesOptions = new Array(60).fill(0).map((item, index) => {
  const id = index;

  return {
    id: id.toString(),
    value: id,
    name: fillWithZeros(id),
  };
});

const Periods = {
  AM: 'am',
  PM: 'pm',
};

const periodOptions = Object.keys(Periods).map(key => ({
  id: Periods[key],
  value: Periods[key],
  name: Periods[key].toUpperCase(),
}));

export {
  fillWithZeros,
  hours24Options,
  hours12Options,
  minutesOptions,
  periodOptions,
  Periods,
};
